// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","pin_dot":"rRvg03","AniFadeIn":"wtjrxV","AniFadeOut":"jk2J87","AniRotate":"rTQzWn","AniPlaceholderFadeOut":"aCBXs5"};